import { ConnectionType, scheduleType, UserType, workflowDataType } from '../../../features/workflow/types';

export namespace workflowRpcClient {
  export function OnSpectatorJoin(data: workflowDataType, users: UserType[]) {
    data.users = {};
    for (const user of users) {
      data.users[user.Id] = user;
    }
    data.user = { ConnectionType: ConnectionType.Spectator };
    return data;
  }
  export function OnCoordinatorJoin(data: workflowDataType, users: UserType[]) {
    data.users = {};
    for (const user of users) {
      data.users[user.Id] = user;
    }
    return data;
  }
  export function OnGetSchedules(data: workflowDataType, schedules: scheduleType[]) {
    data.schedule = {};
    for (const schedule of schedules) {
      data.schedule[schedule.Id] = schedule;
    }
    return data;
  }
  export function OnSpectatorLeave() {
    return { user: {}, users: {}, schedule: {} };
  }
  export function OnLeave(data: workflowDataType, id: string) {
    if (!data.users || data.user?.Id == id || data.user == undefined) {
      return { user: {}, users: {}, schedule: {} };
    }
    delete data.users[id];

    if (data.schedule && data.schedule[id]) {
      delete data.schedule[id];
    }
    return data;
  }
  export function OnSync(data: workflowDataType, user: UserType) {
    data.user = user.ConnectionType == ConnectionType.Lobby ? {} : user;
    data.inactive = false;
    data.updateConnectionType = false;
    return data;
  }
  export function OnUserAdded(data: workflowDataType, user: UserType) {
    if (!data.users) {
      return { [user.Id]: user };
    }
    data.users[user.Id] = user;
    return data;
  }
  export function OnUserDisco(data: workflowDataType, user: UserType) {
    if (!data.users) {
      return data;
    }
    if (data.users[user.Id]) {
      data.users[user.Id] = user;
    }
    return data;
  }

  export function OnUserScheduleUpdate(data: workflowDataType, schedule: scheduleType) {
    if (!data.schedule) {
      data.schedule = {};
    }
    data.schedule[schedule.Id] = schedule;
    if (data.users?.[schedule.Id]) {
      data.users[schedule.Id].Shift = schedule.Shift;
      data.users[schedule.Id].Lunch = schedule.Lunch;
      data.users[schedule.Id].ConnectionType = schedule.IsCoordinator
        ? ConnectionType.Coordinator
        : ConnectionType.Active;
    }
    return data;
  }
  export function OnUserScoreUpdate(data: workflowDataType, scoreId: number, score: number, id: string) {
    if (!data.users || !data.users[id]) {
      return data;
    }
    if (!data.users[id].Scores) {
      data.users[id].Scores = {};
    }
    data.users[id].Scores[scoreId] = score;
    return data;
  }
  export function OnUserStatusUpdate(data: workflowDataType, statusType: number, id: string, message?: string) {
    if (data.user?.Id == id) {
      data.user.Status = statusType;
      data.user.StatusMessage = message;
      return data;
    }
    if (data.users?.[id] != undefined) {
      data.users[id].Status = statusType;
      data.users[id].StatusMessage = message;
    }
    return data;
  }
  export function OnInactive(data: workflowDataType) {
    data.inactive = true;
    return data;
  }
  export function OnConnectionTypeChange(data: workflowDataType) {
    data.updateConnectionType = true;
    return data;
  }
}
